import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, image, url, price, currency = 'MXN', availability = 'instock' }) => {
    const siteTitle = 'MerryColor';
    const finalTitle = title ? `${title} | ${siteTitle}` : 'MerryColor - Distribuidora de Belleza';
    const finalDescription = description || 'Tu destino número uno para cosméticos y productos de belleza en México. Descubre nuestras marcas exclusivas.';
    // Use absolute URL for best compatibility
    const domain = 'https://merrycolor.mx';
    const finalImage = image ? (image.startsWith('http') ? image : `${domain}${image}`) : `${domain}/merry.png`;
    const finalUrl = url ? (url.startsWith('http') ? url : `${domain}${url}`) : domain;

    return (
        <Helmet>
            {/* Standard */}
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />

            {/* Smart App Banner para iOS */}
            {/* Reemplaza YOUR_APP_STORE_ID con el ID numérico real de la app en la App Store */}
            <meta name="apple-itunes-app" content={`app-id=123456789, app-argument=${finalUrl}`} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={price ? "product" : "website"} />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:image" content={finalImage} />
            <meta property="og:url" content={finalUrl} />
            <meta property="og:site_name" content="MerryColor" />

            {/* Open Graph Product (Si aplica) */}
            {price && (
                <>
                    <meta property="product:price:amount" content={price} />
                    <meta property="product:price:currency" content={currency} />
                    <meta property="product:availability" content={availability} />
                </>
            )}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={finalImage} />

            {/* Canonical */}
            <link rel="canonical" href={finalUrl} />
        </Helmet>
    );
};

export default SEO;
